import React, { useContext, useEffect, useRef } from "react";
import { Step, StepLabel, Stepper } from "@mui/material";
import axios from "axios";
import UserRegistration from "./Registration/UserRegistration";
import VenueRegistration from "./Registration/VenueRegistration";
import SubVenueRegistration from "./Registration/SubVenueRegistration";
import { AppContext } from "../Context";
import { VM_Colors } from "../Styles/VMStyles";
import MUITypography from "../Components/MUITypography";
import { API_VENUE_INFO } from "../Util/URLConstants";

const labels = [
  "Personal Information",
  "Venue Registration",
  "Sub-Venue Registration",
];

const handleSteps = (step, registerPending) => {
  switch (step) {
    case 0:
      return <UserRegistration purpose="create" registerPending={registerPending} />;
    case 1:
      return <VenueRegistration />;
    case 2:
      return <SubVenueRegistration />;
    default:
      return null;
  }
};

function StepForm({ registerPending }) {
  const { formValues, activeStep, goToStep } = useContext(AppContext);
  const hasHandledPendingRef = useRef(false);

  useEffect(() => {
    if (!registerPending || hasHandledPendingRef.current) return;

    const pending = registerPending.pending;
    if (!pending) return;

    const resumeRegistration = async () => {
      if (pending === "venue") {
        formValues.user_id = registerPending.user_id;
        goToStep(1); // Venue Registration (2nd step)
        hasHandledPendingRef.current = true;
        return;
      }

      if (pending === "subvenue") {
        formValues.user_id = registerPending.user_id;
        let venueId = registerPending.venue_id;
        // Login pendingdata may omit venue_id — resolve from venue info
        if (!venueId && registerPending.user_id) {
          try {
            const resp = await axios.get(
              `${API_VENUE_INFO}?user_id=${registerPending.user_id}`
            );
            venueId = resp.data?.venue_info?.[0]?.venue_id;
          } catch (err) {
            console.error("Failed to resolve venue_id for subvenue resume", err);
          }
        }
        formValues.venue_id = venueId || "";
        goToStep(2); // Sub-Venue Registration (3rd step)
        hasHandledPendingRef.current = true;
      }
    };

    resumeRegistration();
  }, [registerPending, goToStep, formValues]);

  return (
    <>
      <Stepper
        activeStep={activeStep}
        alternativeLabel
        sx={{
          mb: 4,
          overflowX: { xs: "auto", md: "visible" },
          px: { xs: 1, md: 0 },
        }}
      >
        {labels.map((label) => (
          <Step key={label}>
            <StepLabel
              StepIconProps={{
                sx: {
                  color: VM_Colors.primary,
                  "&.Mui-completed": { color: VM_Colors.secondary },
                },
              }}
            >
              <MUITypography
                variant="h5"
                sx={{
                  fontSize: { xs: 12, sm: 14, md: 16 },
                  textAlign: "center",
                }}
              >
                {label}
              </MUITypography>
            </StepLabel>
          </Step>
        ))}
      </Stepper>

      {handleSteps(activeStep, registerPending)}
    </>
  );
}

export default StepForm;
